module.exports = __webpack_public_path__ + "img/upload_btn.a3a8146c.png";